import { messageThreadService } from './messageThreadService'

/**
 * The message-thread module façade. No store, for the same reason as useMessagePost: the thread
 * list belongs to the page showing it, and the unread count in the header lives in the ui store.
 */
export const useMessageThread = () => {
  return {
    messageThread: {
      service: messageThreadService()
    }
  }
}
